import { store } from '@/config/store';
import { loginType } from '@/consts/login';

/** サーバが横断引き当てに使えるログイン種別 */
export type AiLoginType = typeof loginType.EMAIL | typeof loginType.TELEPHONE;

/**
 * AIへのリクエストに添えるログイン種別を返す
 *
 * AIが参照する顧客レコードの範囲を、車両切替の表示範囲と一致させるために使う。
 * マイくるは loginType が email ならメール、telephone なら電話番号で
 * 顧客レコードを横断する（autoLoginHelper.ts と同じ考え方）。
 *
 * 送るのは種別だけで、識別子の値は送らない。値はサーバが認証済みレコードから引く。
 * SNS連携・旧アプリなど横断対象外の種別は undefined を返し、
 * サーバ側では横断せず自分のレコードだけを見る扱いになる。
 *
 * store はリロードで初期化されるので localStorage も見る。
 */
export const getAiLoginType = (): AiLoginType | undefined => {
  const fromStore = store.state.loginInfo?.loginType;

  const stored = (() => {
    try {
      return window.localStorage.getItem('loginType');
    } catch {
      // プライベートモード等で参照できない場合は無視する
      return null;
    }
  })();

  const value = fromStore || stored;

  if (value === loginType.EMAIL || value === loginType.TELEPHONE) {
    return value;
  }

  return undefined;
};
